module.exports = __webpack_public_path__ + "static/media/MERMELADA DE PIÑA  270 sin octagono (1).77ef9472.png";